import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../../icons/logo";
import CommentIcon from "../../../icons/commentIcon";
import SettingsIcon from "../../../icons/settingsIcon";
import InboxIcon from "../../../icons/inboxIcon";
import PaintBoardIcon from "../../../icons/paintBoardIcon";
import MoneyBagIcon from "../../../icons/moneyBagIcon";
import PinLocationIcon from "../../../icons/pinLocationIcon";
import ScrollIcon from "../../../icons/scrollIcon";
import BoxIcon from "../../../icons/boxIcon";
import HomeIcon from "../../../icons/homeIcon";
import UsersIcon from "../../../icons/usersIcon";
import { primaryColor, secondaryColor } from "../../../utils";
import { useEffect } from "react";

const AgentSideBar = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const links = [
    { path: "/agent/dashboard", label: t("home"), Icon: HomeIcon },
    {
      path: "/agent/dashboard/shipments",
      label: t("Shipments"),
      Icon: BoxIcon,
    },
    {
      path: "/agent/dashboard/issue-bill-of-lading",
      label: t("Issue Bill Of Lading"),
      Icon: ScrollIcon,
    },
    {
      path: "/agent/dashboard/track-shipments",
      label: t("Track Shipments"),
      Icon: PinLocationIcon,
    },
    {
      path: "/agent/dashboard/employees",
      label: t("Employees"),
      Icon: UsersIcon,
    },
    {
      path: "/agent/dashboard/offers-and-prices",
      label: t("Offers And Prices"),
      Icon: MoneyBagIcon,
    },
    {
      path: "/agent/dashboard/visual-identity",
      label: t("Visual Identity"),
      Icon: PaintBoardIcon,
    },
    {
      path: "/agent/dashboard/messages",
      label: t("Messages"),
      Icon: CommentIcon,
    },
    {
      path: "/agent/dashboard/requests",
      label: t("Requests"),
      Icon: InboxIcon,
    },
    { path: "/agent/dashboard/settings", label: t("settings"), Icon: SettingsIcon },
  ];
  useEffect(() => {
    if (!primaryColor) {
      localStorage.setItem("primaryColor", "#0051ff");
    }
    if (!secondaryColor) {
      localStorage.setItem("secondaryColor", "#ff0000");
    }
  }, [pathname]);
  return (
    <aside className="sticky top-0 w-64 min-h-screen bg-white dark:bg-gray-900">
      <Link
        to={"/"}
        className="bg-[#E5EDFF] dark:bg-[#374151] flex items-center py-4 justify-center"
      >
        <Logo />
      </Link>
      <div className="flex flex-col gap-5 p-8 capitalize">
        {links.map(({ path, label, Icon }) => {
          const isActive = pathname === path;

          const textColor = isActive
            ? primaryColor
            : "text-[#6c6c72] dark:text-gray-400 hover:text-black dark:hover:text-white";

          return (
            <Link
              key={path}
              to={path}
              className={`flex items-center gap-2 font-medium  ${textColor}`}
              style={{ color: isActive ? primaryColor : undefined }}
            >
              <span>
                <Icon fill={isActive ? primaryColor : "#888888"} className="size-5" />
              </span>
              <span className="-mb-[3px]">{label}</span>
            </Link>
          );
        })}
      </div>
    </aside>
  );
};

export default AgentSideBar;
